////////////////////////////////////////
// Vendors
////////////////////////////////////////
global.$ = require('jquery');
global.Verge = require('verge');
global._ = require('underscore');
global.Barba = require('barba.js');
global.TimelineMax = require('gsap').TimelineMax;
global.TweenMax = require('gsap').TweenMax;
global.Utils = require('./modules/utils');





////////////////////////////////////////
// Bulb micro Framework
////////////////////////////////////////
const Bulb = require('./modules/bulb');
const Gmap = require('./modules/map');
const Slider = require('./modules/slider');



////////////////////////////////////////
// On configure toutes les vues ici
require('./pages/home').init();
require('./pages/default').init();

let assetsToPreload = false;


class Website extends Bulb{


    initDefaultEvents(){
        Utils.debug('Website : initDefaultEvents');
        history.scrollRestoration = "manual"

        var lastIsLitleSquare = false;
        var doubleOffset = 0;
        var cpt = 0;
        var self = this;

        $('.elementor-widget:not(.elementor-widget-roxane-studycase, .elementor-widget-roxane-news), .works-header, .works-infos, .parallaxable').each(function(elt){
            $(this).addClass('parallaxable');
            var offset = Verge.viewportW() / 8;
            if($(this).hasClass('ratio-1x1') && lastIsLitleSquare && !doubleOffset){
                offset = offset*2;
                doubleOffset = true;
            } else {
                doubleOffset = false;
            }
            $(this).attr('data-level', offset);
            lastIsLitleSquare = $(this).hasClass('ratio-1x1');
            cpt ++;
        });



        $('.scrollToTop').addClass('parallaxable');
        $('.scrollToTop').attr('data-level', 1000);


        $('.gmap').each(function(){
            var myMap = new Gmap($(this));
        });

        $('.slider').each(function(){
            var mySlider = new Slider($(this));
        });

        // on switch les ordres pour les bloc alterné uniquement sur mobile
        if(this.device.isXs){
            Utils.debug('Invert bloc');
            $('.mobileinvert-yes').each(function(){
                let prev = $(this).prev().get(0);
                let next = $(this).get(0);
                Utils.swapNodes(prev, next);

            });
        }

        // gestion du decalage du site par le footer
        $('body').on('scrolling', function(event){

            if(event.device.isDesktop){
                let $footer =  $('footer');
                if($footer.length){
                    let footerOffset = $('footer').get(0).getBoundingClientRect();
                    let vpHeight = Verge.viewportH();
                    let partVisible =  vpHeight - footerOffset.top;

                    if(partVisible > 0 && footerOffset.top > 0 ){
                        TweenMax.set($('.background, .homeEffect'), {y: - Math.ceil(partVisible) + 2});
                    } else {
                        TweenMax.set($('.background, .homeEffect'), {y: 0});
                    }
                }
            }

        });


        $('#app').on('mouseover', '.elementor-widget-video', function(){
            Utils.debug('reloadPageOnResize ==> false');
            self.reloadPageOnResize = false;
        });
        $('#app').on('mouseleave', '.elementor-widget-video', function(){

            setTimeout(function () {
                Utils.debug('reloadPageOnResize ==> true');
                self.reloadPageOnResize = true;
            }, 300)
        });

			// on va rajouter un padding dynamique pour ajuster le footer
			var $myFooter = $('footer');
			$('.mainContent').css({
				'paddingBottom': $myFooter.eq($myFooter.length - 1).innerHeight() + 100
			});



			this.scrollToAnchorAndMore();
        window.onhashchange = this.scrollToAnchorAndMore;



    }

    scrollToAnchorAndMore(){

        //console.debug('app.js : scrollToAnchorAndMore');
        $(window).scrollTop(0);
        if(document.location.hash != ""){
            let id = document.location.hash.substr(1);
            let divToScroll = $('[data-id="'+id+'"]');
            if(divToScroll.length > 0){
                $(window).scrollTop( divToScroll.offset().top - Utils.getTranslateY(divToScroll) );
            }
        }
    }


    removeDefaultEvents(){
        Utils.debug('Website : removeDefaultEvents');
        //$('body').off('scrolling');
    }

}

////////////////////////////////////////
$('document').ready(function () {
    let App = new Website();
})

